function initMegaMenu() {
    function findItemToShow(nodeList, e) {
        return [...nodeList].find(node => {
            return node.dataset.sandroMenu === e.currentTarget.dataset.sandroMenu && !node.hasAttribute('open')
        }) || null;
    }

    function findItemToHide(nodeList, e) {
        return [...nodeList].find(node => {
            return node.hasAttribute('open') && node.dataset.sandroMenu !== e.currentTarget.dataset.sandroMenu
        }) || null;    
    }

    const menus = document.querySelectorAll('.sandro-mega-menu__content');

    menus.forEach(menu => {
        const [accordions, hiddenMenus] = [
            menu.querySelectorAll('li[data-sandro-menu]'), 
            menu.querySelectorAll('ul[data-sandro-menu]'), 
        ];

        accordions.forEach(accordion => {
            accordion.addEventListener('mouseenter', (e) => {
                // console.log('Hello')
                e.preventDefault();


                const menuToOpen = findItemToShow(hiddenMenus, e);
                const menuToClose = findItemToHide(hiddenMenus, e);
    
                if (!menuToOpen) {
                    if (menuToClose) menuToClose.removeAttribute('open');
                    return;
                }
    
                const isOpen = menuToOpen.getAttribute('open') || false;

                if (!isOpen) {
    
                    menuToOpen.setAttribute('open', true);
                    if (menuToClose) menuToClose.removeAttribute('open');
                }
            });
        })
    })
}

if (window.innerWidth > 990) initMegaMenu();

